module.exports = __webpack_public_path__ + "static/img/Built.552df0c6.svg";